import { ReactNode } from 'react';
import {
  QueryClientProvider as ReactQueryQueryClientProvider,
  QueryClient,
} from '@tanstack/react-query';

import { MrtAxiosException } from '../../types/api';
import { CODE_LIST_FOR_USING_SERVER_ERROR_MESSAGE } from '../../constants/api';
import { openErrorToastByCode, openErrorToastByMessage } from '../../utils/openErrorToast';

function handleError(error: unknown) {
  const { code = '', message } = error as MrtAxiosException;

  if (CODE_LIST_FOR_USING_SERVER_ERROR_MESSAGE.includes(code) && message) {
    openErrorToastByMessage({ message });

    return;
  }

  openErrorToastByCode({
    code,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15000,
      onError: handleError,
    },
    mutations: {
      onError: handleError,
    },
  },
});
interface PropsType {
  children: ReactNode;
}

function QueryClientProvider({ children }: PropsType) {
  return (
    <ReactQueryQueryClientProvider client={queryClient}>{children}</ReactQueryQueryClientProvider>
  );
}

export default QueryClientProvider;
